<div class="cea-card card-product-spotlight" [style.backgroundImage]="getImageFilePath()">
    <div class="card-product-spotlight-overlay">
        <span class="card-product-spotlight-indicator"></span>
        <div class="card-header card-product-spotlight-header">
            <h2 class="card-title card-product-spotlight-title">
                {{ title_translated }}
            </h2>
        </div>
        <div class="card-body card-product-spotlight-body">
            <p>{{ textContent_translated }}</p>
        </div>
    </div>
</div>